import { useState, useCallback } from 'react';
import { adminAPI } from '@/services/api';
import { Customer } from '@/types';

export const useCustomerActions = (onSuccess: () => void) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const createCustomer = useCallback(async (customerData: any) => {
    setLoading(true);
    setError('');
    try {
      const result = await adminAPI.createCustomer(customerData);
      onSuccess();
      return result;
    } catch (err: any) {
      setError(err.response?.data?.detail || '고객사 생성에 실패했습니다.');
      throw err;
    } finally {
      setLoading(false);
    }
  }, [onSuccess]);

  const updateCustomer = useCallback(async (customerId: number, updates: Partial<Customer>) => {
    setLoading(true);
    setError('');
    try {
      await adminAPI.updateCustomer(customerId, updates);
      onSuccess();
    } catch (err: any) {
      setError(err.response?.data?.detail || '고객사 정보 수정에 실패했습니다.');
      throw err;
    } finally {
      setLoading(false);
    }
  }, [onSuccess]);

  const deactivateCustomer = useCallback(async (customerId: number) => {
    setLoading(true);
    setError('');
    try {
      await adminAPI.deactivateCustomer(customerId);
      onSuccess();
    } catch (err: any) {
      setError(err.response?.data?.detail || '고객사 비활성화에 실패했습니다.');
      throw err;
    } finally {
      setLoading(false);
    }
  }, [onSuccess]);

  const activateCustomer = useCallback(async (customerId: number) => {
    setLoading(true);
    setError('');
    try {
      await adminAPI.activateCustomer(customerId);
      onSuccess();
    } catch (err: any) {
      setError(err.response?.data?.detail || '고객사 활성화에 실패했습니다.');
      throw err;
    } finally {
      setLoading(false);
    }
  }, [onSuccess]);

  const deleteCustomer = useCallback(async (customerId: number) => {
    setLoading(true);
    setError('');
    try {
      await adminAPI.deleteCustomer(customerId);
      onSuccess();
    } catch (err: any) {
      setError(err.response?.data?.detail || '고객사 삭제에 실패했습니다.');
      throw err;
    } finally {
      setLoading(false);
    }
  }, [onSuccess]);

  return {
    loading,
    error,
    setError,
    createCustomer,
    updateCustomer,
    deactivateCustomer,
    activateCustomer,
    deleteCustomer,
  };
};

